export default "__VITE_ASSET__KwJYy4ZE__"